import { useState, useEffect, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { Input, InputGroup, InputGroupText } from "design-react-kit";
import {
  normalizeMoney,
  toUiMoney,
  clampPercent,
  sanitizeMoneyInput,
} from "../../Utility/money";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditRange(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [range, setRange] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);

  const query = useQuery();
const hasText = (v) => typeof v === "string" && v.trim() !== "";
  useEffect(() => {
    setLoading(false);
    const id = query.get("range");
    if (id != null) {
      Repo.getRangeById(apiToken, id)
        .then((response) => {
          const r = response.data;
          setRange({
            ...r,
            fixedCost: toUiMoney(r.fixedCost), // UI con virgola
            min: r.min ?? "",
            max: r.max ?? "",
            percent: r.percent ?? "",
          });
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    } else {
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rangeEditValidation = () => {
    setValidation(true);
    let passedValidation = true;

    if (!range?.name) passedValidation = false;
    if (range?.min === null || range?.min === "" || range?.min === undefined) passedValidation = false;
    if (range?.max === null || range?.max === "" || range?.max === undefined) passedValidation = false;
    if (range?.fixedCost === null || range?.fixedCost === "" || range?.fixedCost === undefined) passedValidation = false;

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const updateRangeAPI = () => {
    const payload = {
      ...range,
      min: range.min !== null && range.min !== "" ? Number(range.min) : null,
      max: range.max !== null && range.max !== "" ? Number(range.max) : null,
      fixedCost: normalizeMoney(range.fixedCost), // numero con punto e 2 decimali
      percent: clampPercent(range.percent),
    };

    Repo.postUpdateRange(apiToken, JSON.stringify(payload))
      .then((response) => {
        if (response.status === 200) {
          window.location.href = props.subfolder + "/fasce";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePercentChange = (e) => {
    setRange({ ...range, percent: clampPercent(e.target.value) });
  };

  // Non bloccare: sanitizza e accetta stati intermedi (",", "12,", ecc.)
  const handleFixedCostChange = (e) => {
    const v = sanitizeMoneyInput(e.target.value);
    setRange({ ...range, fixedCost: v });
  };

  // onBlur: formatta a 2 decimali (es. "12," -> "12,00")
  const handleFixedCostBlur = () => {
    if (!range) return;
    const n = normalizeMoney(range.fixedCost);
    setRange({ ...range, fixedCost: toUiMoney(n) });
  };

  return (
    <div>
      <h1>Modifica fascia ISEE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p> </p>
      </div>

      <div className="row">
        <div className="col-lg-4">
          <Input
            id="first_name"
            disabled={isDisabled}
            label="Nome*"
            type="text"
            name="first_name"
            value={range ? range.name ?? "" : ""}
            {...(validation &&
              (!range?.name) && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setRange({ ...range, name: e.target.value })}
          />
        </div>

        <div className="col-lg-4">
          <Input
            id="min_value"
            disabled={isDisabled}
            label="Valore Minimo*"
            type="number"
            name="min_value"
            min={0}
            value={range ? String(range.min ?? "") : ""}
            {...(validation &&
              (range?.min === null || range?.min === "" || range?.min === undefined) && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setRange({ ...range, min: e.target.value })}
          />
        </div>

        <div className="col-lg-4">
          <Input
            id="max_value"
            disabled={isDisabled}
            label="Valore Massimo*"
            type="number"
            name="max_value"
            min={0}
            value={range ? String(range.max ?? "") : ""}
            {...(validation &&
              (range?.max === null || range?.max === "" || range?.max === undefined) && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setRange({ ...range, max: e.target.value })}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-6">
          <label htmlFor="percentage">Percentuale</label>
          <div className="input-number input-number-percentage">
            <Input
              id="percentage"
              disabled={isDisabled}
              type="number"
              name="percentage"
              min={0}
              max={100}
              value={range ? String(range.percent ?? "") : ""}
              onChange={handlePercentChange}
            />
          </div>
        </div>

      <div className="col-lg-6">
        <label htmlFor="fixed_cost">Quota Fissa*</label>
        <InputGroup className="mb-0">
          <InputGroupText>€</InputGroupText>
          <Input
            id="fixed_cost"
            disabled={isDisabled}
            type="text"
            inputMode="decimal"
            name="fixed_cost"
            value={range ? (range.fixedCost ?? "") : ""}
            onChange={handleFixedCostChange}
            onBlur={handleFixedCostBlur}
            // rimuovi le vecchie classi che creavano il simbolo via CSS:
            // niente "input-number-currency"
          />
        </InputGroup>
      </div>
      </div>

      {isDisabled ? (
        <div className="row my-2">
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => setIsDisabled(!isDisabled)}
              title="Modifica"
            >
              Modifica
            </button>
          </div>
        </div>
      ) : (
        <div className="row my-2">
          <div className="col-lg-10 text-right">
            <button
              type="button"
              className="btn btn-outline-info"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => setIsDisabled(!isDisabled)}
              title="Indietro"
            >
              Indietro
            </button>
          </div>
          <div className="col-lg-2 text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={rangeEditValidation}
              title="Conferma"
            >
              Conferma
            </button>
          </div>
        </div>
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica fascia ISEE"
        body="Confermi di voler modificare la fascia ISEE selezionata?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={updateRangeAPI}
      />

      {!loading && <Loader />}
    </div>
  );
}

export default EditRange;
